// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#ffffff","menuActiveText":"#ffffff","subMenuActiveText":"#ffffff","menuBg":"#2179FE","menuHover":"#1968E2","subMenuBg":"#2179FE","subMenuHover":"#1968E2","sideBarWidth":"240px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = 379
// module chunks = 289